import './Pyschometric.css';
import React, { useRef, useState,useEffect } from "react";
import Webcam from "react-webcam";
import micImg from '../../Assets/circle.png';
import muteImg from '../../Assets/mute.png';
import { SendVideo } from '../../services/PyschometricTest';
import { useNavigate } from 'react-router-dom';

function PyschometricCamera()
{
    const webcamRef = useRef(null);
    const navigate=useNavigate();
    const mediaRecorderRef = useRef(null);
    const [recording, setRecording] = useState(false);
    const [recordedChunks, setRecordedChunks] = useState([]);
    const [mute,setMute]=useState(true);
    const [cameraEnabled, setCameraEnabled] = useState(false);
    const [micEnabled, setMicEnabled] = useState(false);
    const [error, setError] = useState('');

    // const micHandler=()=>{
    //    mute==false?setMute(true):setMute(false);
    // };

    const startRecording = () => {
        setRecording(true);
        setRecordedChunks([]);
        const stream = webcamRef.current.video.srcObject;
        const mediaRecorder = new MediaRecorder(stream, {
          mimeType: "video/webm", // Use "video/mp4" if supported by your browser
        });
    
        mediaRecorderRef.current = mediaRecorder;
    
        mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            setRecordedChunks((prev) => prev.concat(event.data));
          }
        };
    
        mediaRecorder.start();
      };
    
      const stopRecording = () => {
        setRecording(false);
        mediaRecorderRef.current.stop();
        downloadRecording();
      };
    
      const downloadRecording = () => {
        const blob = new Blob(recordedChunks, { type: "video/webm" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "recording.webm";
        document.body.appendChild(a);
        // a.click();
        // window.URL.revokeObjectURL(url);
        SendVideoBackend(blob)
        setRecordedChunks([]);
      };
      React.useEffect(() => {
        if (!recording && recordedChunks.length > 0) {
          downloadRecording(); 
        }
      }, [recording, recordedChunks]);

      async function SendVideoBackend(video){
        const dataReceived=await SendVideo(video);
        if(dataReceived)
        {
          console.log(dataReceived);
        }
      }


      useEffect(() => {
    const checkCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            setCameraEnabled(true);
            // Don't stop the stream - keep it active so camera stays on
            // stream.getTracks().forEach(track => track.stop());
        } catch (err) {
            setError('Camera access denied. Please enable camera permissions.');
            setCameraEnabled(false);
        }
    };
    checkCamera();
}, []);

// Simplified mic handler - just check permission, don't toggle state
const micHandler = async () => {
    try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        setMicEnabled(true);
        setError(''); // Clear error
        stream.getTracks().forEach(track => track.stop()); // Stop test stream
    } catch (err) {
        setError('Microphone access denied. Please enable microphone permissions.');
        setMicEnabled(false);
    }
};
    return(
    <>
     <div className='pyschometrictestcontainer'>
         <section className='pyschometrictext'>
            <h2>Pyschometric Test</h2>
            <h4><span>Home</span><span > &nbsp; &gt; Pyschometric Test </span> <span style={{color:"#8A090D"}}>&nbsp; &gt; Quiz</span> </h4>
         </section>
       <section className='pyschometriccamera'>
    <h3>Please turn on your web cam and microphone to start the test</h3>
    {error && <p style={{color: 'red', marginTop: '10px'}}>{error}</p>}
    
    <div style={{marginTop: '10px', marginBottom: '10px'}}>
        <span style={{color: cameraEnabled ? 'green' : 'red'}}>
            {cameraEnabled ? '✓ Camera Ready' : '✗ Camera Not Ready'}
        </span>
        {' | '}
        <span style={{color: micEnabled ? 'green' : 'red'}}>
            {micEnabled ? '✓ Microphone Ready' : '✗ Click mic icon to enable'}
        </span>
    </div>
    
    <div>
        <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={{
                width: 1280,
                height: 720,
                facingMode: "user",
            }}
            className='cam'
        />
    </div>
    <div className='camerabtns'>
        <img 
            src={micEnabled ? micImg : muteImg} 
            width='40' 
            height='40' 
            alt='mic' 
            className='mic' 
            onClick={micHandler}
            style={{cursor: 'pointer'}}
        />
    </div>
</section>
         
      </div>
         <footer className='bottombar'>
            <div className='proceedbtns'>
                <button 
                    type='button'
                    onClick={()=>navigate('/pyschometrictest/questions')}
                    disabled={!cameraEnabled || !micEnabled}
                    style={{backgroundColor:`${!micEnabled || !cameraEnabled? 'grey':'#8A090D'}`}}
                >
                  Next
                </button>
            </div>
        </footer>
    </>);
}

export default PyschometricCamera;